import React from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import './ChildSafety.css'; // Assuming custom styles will be in this file
import Llogo from '../img/Llogo.png';

const ChildSafety = () => {
  return (

      <div style={styles.container}>
            <header style={styles.header}>
        <img src={Llogo} alt="Logo" style={styles.logo} />
        <h1 style={styles.title}>Welcome to Lions Directory</h1>
      </header>
          <Container className="child-safety-container">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="child-safety-card">
            <Card.Body>
              <Card.Title className="text-center">
                <h2>Child Safety Standards Policy</h2>
              </Card.Title>
              <Card.Text>
                <p>
                  <strong className="company-name">Lions Directory Platform</strong>, we prioritize the safety and well-being of children using our services.
                  This policy outlines our commitment to child protection and compliance with Google Play Store’s Families Policy and Child Safety Standards.
                </p>
                <h4>1. Compliance with Child Safety Laws</h4>
                <ul>
                  <li>Children’s Online Privacy Protection Act (COPPA) (for users in the U.S.)</li>
                  <li>General Data Protection Regulation (GDPR-K) (for users in the EU)</li>
                  <li>Google Play’s Families Policy Requirements</li>
                </ul>
                <h4>2. Age-Appropriate Content</h4>
                <p>Our app is designed for users aged <strong>10-18</strong>.</p>
                <p>We ensure that all content is child-friendly and free from harmful, inappropriate, or adult-oriented materials.</p>
                <h4>3. Data Collection and Privacy</h4>
                <p>We do not collect personal information from children without parental consent.</p>
                <p>Any data collected is handled securely and in compliance with applicable child protection regulations.</p>
                <h4>4. Advertisements and In-App Purchases</h4>
                <p>Our app uses Google Play-certified Families Ad Networks to display age-appropriate ads.</p>
                <p>We provide parental controls to manage in-app purchases.</p>
                <h4>5. Reporting and Safety Measures</h4>
                <Alert variant="warning">
                  If you suspect any violation of child safety, please report it to <a href="mailto:emedhatechnologies@gmail.com">emedhatechnologies@gmail.com</a>.
                  We take immediate action on reports regarding inappropriate content or abuse.
                </Alert>
                <p>For more information, visit our <a href="https://emedha.com/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              
       
                </p>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f4f4f4',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  header: {
    width: '100%',
    backgroundColor: '#002366', // Navy Blue
    color: '#FFD700', // Gold
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  logo: {
    height: '60px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
}

export default ChildSafety;
